import { render, staticRenderFns } from "./Commodity.vue?vue&type=template&id=cdfd38d8&scoped=true&"
import script from "./Commodity.vue?vue&type=script&lang=js&"
export * from "./Commodity.vue?vue&type=script&lang=js&"
import style0 from "./Commodity.vue?vue&type=style&index=0&id=cdfd38d8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdfd38d8",
  null
  
)

export default component.exports